import { ref, onValue, push, set } from "firebase/database";
import { useEffect, useState } from "react";
import { auth, database } from "../firebase";

const Surveys = () => {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = auth?.currentUser;

  useEffect(() => {
  const style = document.createElement("style");
  style.innerHTML = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }

    @keyframes slideDown {
      0% { opacity: 0; transform: translateY(-20px); }
      100% { opacity: 1; transform: translateY(0); }
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }

    .survey-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 10px 20px rgba(143, 39, 255, 0.15);
    }
  `;
  document.head.appendChild(style);
  return () => document.head.removeChild(style);
}, []);


  useEffect(() => {
    if (!user) return;

    const surveysRef = ref(database, "LiveSurveys");
    const takenRef = ref(database, `SurveyTaken/${user.uid}`);

    const unsubscribe = onValue(surveysRef, (snapshot) => {
      const allSurveys = snapshot.val() || {};

      onValue(takenRef, (takenSnapshot) => {
        const takenData = takenSnapshot.val() || {};
        const takenIds = new Set(
          Object.values(takenData).map((entry) => entry.surveyId)
        );

        const availableSurveys = Object.entries(allSurveys)
          .map(([id, survey]) => ({ id, ...survey }))
          .filter((survey) => !takenIds.has(survey.Id));

        setSurveys(availableSurveys);
        setLoading(false);
      });
    });

    return () => unsubscribe();
  }, [user]);

  const handleParticipate = async (survey) => {
    const user = auth?.currentUser;
    const takenRef = ref(database, `SurveyTaken/${user.uid}`);
    const newSurveyRef = push(takenRef);

    const newData = {
      surveyId: survey?.Id,
      title: survey?.Title || "",
      reward: survey?.Reward || "",
      timestamp: new Date().toISOString(),
    };

    try {
      await set(newSurveyRef, newData);
      if (survey.Link) {
        window.open(survey?.Link + user.uid, "_blank");
      }
    } catch (error) {
      console.error("Error saving participation:", error);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h3 style={styles.highlightedTitle}>Available Surveys</h3>

        {loading ? (
          <div style={styles.loaderWrapper}>
            <div style={styles.loader}></div>
            <p style={styles.loadingText}>Loading surveys...</p>
          </div>
        ) : surveys.length === 0 ? (
          <p style={styles.noDataText}>No surveys available at the moment.</p>
        ) : (
          surveys.map((survey) => (
            <div key={survey.id} style={styles.card}>
              <div style={styles.cardContent}>
                <div style={styles.title}>
                  #{survey.Id} - {survey.Title}
                </div>
                <div style={styles.reward}>
                  🪙 {survey.Reward}
                </div>
              </div>
              <button
                onClick={() => handleParticipate(survey)}
                style={styles.button}
              >
                Participate
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Surveys;

const styles = {
  wrapper: {
    background: "linear-gradient(to bottom right, #F3EBFF, #ffffff)",
    minHeight: "100vh",
    padding: "40px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    width: "100%",
    maxWidth: 960,
    animation: "fadeIn 0.6s ease-in-out",
  },
  highlightedTitle: {
    fontSize: 28,
    fontWeight: 800,
    background: "linear-gradient(to right, #8F27FF, #15007d)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textAlign: "center",
    marginBottom: 36,
    letterSpacing: 1,
    textTransform: "uppercase",
    animation: "slideDown 0.5s ease-out",
  },
  loaderWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 60,
  },
  loader: {
    width: 48,
    height: 48,
    border: "6px solid #f3f3f3",
    borderTop: "6px solid #15007d",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: "#15007d",
    fontWeight: "600",
    animation: "pulse 1.5s ease-in-out infinite",
  },
  noDataText: {
    fontSize: 16,
    color: "#666",
    textAlign: "center",
    fontWeight: 500,
    marginTop: 40,
  },
  card: {
    background: "#fff",
    border: "2px solid #8F27FF",
    borderRadius: 12,
    padding: 20,
    marginBottom: 16,
    boxShadow: "0 6px 20px rgba(143, 39, 255, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  title: {
    fontWeight: 700,
    fontSize: 16,
    color: "#200D41",
    background: "linear-gradient(to right, #15007d, #8F27FF)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  reward: {
    fontSize: 15,
    fontWeight: 600,
    color: "#b8860b",
  },
  button: {
    backgroundColor: "#15007d",
    color: "white",
    border: "none",
    padding: "8px 18px",
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  },
};

